/* ==========================================================================
   Maher Motors — theme behaviour
   Vanilla JS, no dependencies, no build step.
   ========================================================================== */

(function () {
  'use strict';

  var routes = window.routes || {};
  var strings = window.themeStrings || {};

  /* ---------------------------------------------------------------- utils */

  function $(sel, ctx) {
    return (ctx || document).querySelector(sel);
  }
  function $$(sel, ctx) {
    return Array.prototype.slice.call((ctx || document).querySelectorAll(sel));
  }
  function debounce(fn, wait) {
    var t;
    return function () {
      var args = arguments;
      var ctx = this;
      clearTimeout(t);
      t = setTimeout(function () {
        fn.apply(ctx, args);
      }, wait);
    };
  }

  var FOCUSABLE =
    'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), ' +
    'select:not([disabled]), textarea:not([disabled]), summary, [tabindex]:not([tabindex="-1"])';

  var loadingBar = $('[data-loading-bar]');
  function setLoading(on) {
    if (!loadingBar) return;
    loadingBar.classList.toggle('is-loading', !!on);
  }

  /* --------------------------------------------------------------- drawers */

  var openDrawerEl = null;
  var lastTrigger = null;

  function openDrawer(id, trigger) {
    var drawer = document.getElementById(id);
    if (!drawer) return;

    lastTrigger = trigger || document.activeElement;
    drawer.hidden = false;
    // Force a reflow so the transition runs from the closed state.
    void drawer.offsetWidth;
    drawer.classList.add('is-open');
    document.body.classList.add('is-locked');
    openDrawerEl = drawer;

    if (trigger) trigger.setAttribute('aria-expanded', 'true');

    var panel = $('.drawer__panel', drawer);
    var first = panel ? $(FOCUSABLE, panel) : null;
    if (first) first.focus();
  }

  function closeDrawer(drawer) {
    drawer = drawer || openDrawerEl;
    if (!drawer) return;

    drawer.classList.remove('is-open');
    document.body.classList.remove('is-locked');

    $$('[data-drawer-open="' + drawer.id + '"]').forEach(function (btn) {
      btn.setAttribute('aria-expanded', 'false');
    });

    window.setTimeout(function () {
      if (!drawer.classList.contains('is-open')) drawer.hidden = true;
    }, 260);

    if (lastTrigger && document.contains(lastTrigger)) lastTrigger.focus();
    openDrawerEl = null;
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      // Cart icon falls back to the cart page when the drawer is disabled.
      var id = opener.getAttribute('data-drawer-open');
      if (document.getElementById(id)) {
        e.preventDefault();
        openDrawer(id, opener);
      }
      return;
    }

    if (e.target.closest('[data-drawer-close]')) {
      e.preventDefault();
      closeDrawer(e.target.closest('[data-drawer]'));
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (openDrawerEl) {
        closeDrawer();
      } else if (searchPanel && searchPanel.classList.contains('is-open')) {
        closeSearch();
      }
      return;
    }

    if (e.key !== 'Tab' || !openDrawerEl) return;

    var panel = $('.drawer__panel', openDrawerEl);
    if (!panel) return;
    var items = $$(FOCUSABLE, panel).filter(function (el) {
      return el.offsetParent !== null;
    });
    if (!items.length) return;

    var first = items[0];
    var last = items[items.length - 1];

    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  });

  /* ---------------------------------------------------------------- search */

  var searchPanel = $('[data-search-panel]');

  function openSearch(trigger) {
    if (!searchPanel) return;
    searchPanel.hidden = false;
    void searchPanel.offsetWidth;
    searchPanel.classList.add('is-open');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    var input = $('[data-search-input]', searchPanel);
    if (input) {
      input.focus();
      input.select();
    }
  }

  function closeSearch() {
    if (!searchPanel) return;
    searchPanel.classList.remove('is-open');
    $$('[data-search-open]').forEach(function (b) {
      b.setAttribute('aria-expanded', 'false');
    });
    window.setTimeout(function () {
      if (!searchPanel.classList.contains('is-open')) searchPanel.hidden = true;
    }, 240);
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-search-open]');
    if (opener) {
      e.preventDefault();
      openSearch(opener);
      return;
    }
    if (e.target.closest('[data-search-close]')) {
      e.preventDefault();
      closeSearch();
      return;
    }
    // Click outside the open panel closes it.
    if (
      searchPanel &&
      searchPanel.classList.contains('is-open') &&
      !e.target.closest('[data-search-panel]') &&
      !e.target.closest('[data-search-open]')
    ) {
      closeSearch();
    }
  });

  /* Predictive search */
  (function predictiveSearch() {
    if (!searchPanel || !routes.predictive_search_url) return;

    var input = $('[data-search-input]', searchPanel);
    var results = $('[data-predictive-results]', searchPanel);
    if (!input || !results) return;

    var controller = null;

    var run = debounce(function () {
      var term = input.value.trim();

      if (term.length < 2) {
        results.innerHTML = '';
        input.setAttribute('aria-expanded', 'false');
        return;
      }

      if (controller) controller.abort();
      controller = new AbortController();

      var url =
        routes.predictive_search_url +
        '?q=' +
        encodeURIComponent(term) +
        '&resources[type]=product,page,article&resources[limit]=5' +
        '&section_id=predictive-search';

      setLoading(true);

      fetch(url, { signal: controller.signal })
        .then(function (r) {
          return r.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var content = doc.querySelector('.predictive');
          results.innerHTML = content ? content.outerHTML : '';
          input.setAttribute('aria-expanded', results.innerHTML ? 'true' : 'false');
        })
        .catch(function (err) {
          if (err.name !== 'AbortError') results.innerHTML = '';
        })
        .finally(function () {
          setLoading(false);
        });
    }, 220);

    input.addEventListener('input', run);
  })();

  /* ------------------------------------------------------------------ cart */

  function updateCartCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  function refreshCartDrawer(sections, reopen) {
    var wrapper = document.getElementById('shopify-section-cart-drawer');
    if (!wrapper || !sections || !sections['cart-drawer']) return;

    var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
    var fresh = doc.querySelector('#shopify-section-cart-drawer') || doc.body;
    wrapper.innerHTML = fresh.innerHTML;

    if (reopen) openDrawer('cart-drawer');
  }

  function cartRequest(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) throw data;
        return data;
      });
    });
  }

  /* Add to cart */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;

    // Without a drawer, let the browser post normally.
    if (!document.getElementById('cart-drawer')) return;

    e.preventDefault();

    var button = $('[data-add-to-cart]', form);
    var label = button ? $('[data-add-to-cart-text]', button) : null;
    var errorEl = $('[data-cart-error]', form);
    var original = label ? label.textContent : '';

    if (errorEl) {
      errorEl.hidden = true;
      errorEl.textContent = '';
    }
    if (button) button.disabled = true;
    if (label) label.textContent = '…';
    setLoading(true);

    var data = new FormData(form);
    var payload = { sections: 'cart-drawer', sections_url: window.location.pathname };
    data.forEach(function (value, key) {
      if (key === 'quantity') {
        payload.quantity = parseInt(value, 10) || 1;
      } else if (key === 'id') {
        payload.id = value;
      } else if (key.indexOf('properties[') === 0) {
        payload.properties = payload.properties || {};
        payload.properties[key.slice(11, -1)] = value;
      } else if (key === 'selling_plan') {
        payload.selling_plan = value;
      }
    });

    cartRequest(routes.cart_add_url + '.js', payload)
      .then(function (res) {
        refreshCartDrawer(res.sections, true);
        return fetch(routes.cart_url + '.js')
          .then(function (r) {
            return r.json();
          })
          .then(function (cart) {
            updateCartCount(cart.item_count);
          });
      })
      .catch(function (err) {
        if (errorEl) {
          errorEl.textContent = (err && (err.description || err.message)) || strings.cartError || 'Error';
          errorEl.hidden = false;
        }
      })
      .finally(function () {
        if (button) button.disabled = false;
        if (label) label.textContent = original;
        setLoading(false);
      });
  });

  /* Line item quantity + removal */
  function changeLine(key, quantity) {
    setLoading(true);
    var isDrawerOpen = openDrawerEl && openDrawerEl.id === 'cart-drawer';

    return cartRequest(routes.cart_change_url + '.js', {
      id: key,
      quantity: quantity,
      sections: 'cart-drawer',
      sections_url: window.location.pathname
    })
      .then(function (cart) {
        updateCartCount(cart.item_count);

        if (document.body.classList.contains('template-cart')) {
          window.location.reload();
          return;
        }
        refreshCartDrawer(cart.sections, isDrawerOpen);
      })
      .catch(function () {
        window.location.reload();
      })
      .finally(function () {
        setLoading(false);
      });
  }

  document.addEventListener('click', function (e) {
    var remove = e.target.closest('[data-cart-remove]');
    if (remove) {
      e.preventDefault();
      changeLine(remove.getAttribute('data-line-key'), 0);
    }
  });

  document.addEventListener(
    'change',
    function (e) {
      var qty = e.target.closest('[data-cart-qty]');
      if (!qty) return;
      var value = parseInt(qty.value, 10);
      if (isNaN(value) || value < 0) value = 0;
      changeLine(qty.getAttribute('data-line-key'), value);
    },
    true
  );

  /* ------------------------------------------------------- quantity steppers */

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-up], [data-qty-down]');
    if (!btn) return;

    var wrap = btn.closest('.qty');
    var input = wrap ? $('input', wrap) : null;
    if (!input) return;

    var step = btn.hasAttribute('data-qty-up') ? 1 : -1;
    var min = parseInt(input.getAttribute('min'), 10);
    if (isNaN(min)) min = 0;
    var max = parseInt(input.getAttribute('max'), 10);

    var next = (parseInt(input.value, 10) || 0) + step;
    if (next < min) next = min;
    if (!isNaN(max) && next > max) next = max;

    if (String(next) === input.value) return;
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* --------------------------------------------------------- variant picker */

  (function variantPicker() {
    var dataEl = $('[data-product-variants]');
    var picker = $('[data-variant-picker]');
    if (!dataEl) return;

    var variants;
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (err) {
      return;
    }
    if (!variants || !variants.length || !picker) return;

    function selectedOptions() {
      var checked = $$('input[type="radio"]:checked', picker);
      var out = [];
      checked.forEach(function (input) {
        var pos = parseInt(input.getAttribute('data-option-position'), 10);
        out[pos - 1] = input.value;
      });
      return out;
    }

    function match(options) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var ok = true;
        for (var j = 0; j < options.length; j++) {
          if (v.options[j] !== options[j]) {
            ok = false;
            break;
          }
        }
        if (ok) return v;
      }
      return null;
    }

    picker.addEventListener('change', function (e) {
      if (!e.target.matches('input[type="radio"]')) return;

      var options = selectedOptions();
      var variant = match(options);

      // Reflect the chosen value next to each option label.
      $$('input[type="radio"]:checked', picker).forEach(function (input) {
        var pos = input.getAttribute('data-option-position');
        var out = $('[data-option-value="' + pos + '"]', picker);
        if (out) out.textContent = input.value;
      });

      var idInput = $('[data-variant-id]');
      var button = $('[data-add-to-cart]');
      var label = button ? $('[data-add-to-cart-text]', button) : null;
      var priceTarget = $('[data-price-target]');
      var stockTarget = $('[data-stock-target]');

      if (!variant) {
        if (button) button.disabled = true;
        if (label) label.textContent = strings.unavailable || 'Unavailable';
        return;
      }

      if (idInput) {
        idInput.value = variant.id;
        idInput.disabled = false;
      }
      if (button) button.disabled = !variant.available;
      if (label) {
        label.textContent = variant.available
          ? strings.addToCart || 'Add to cart'
          : strings.soldOut || 'Sold out';
      }
      if (priceTarget && variant.price_html) priceTarget.innerHTML = variant.price_html;
      if (stockTarget) {
        stockTarget.className =
          'product__stock product__stock--' + (variant.available ? 'in' : 'out');
        stockTarget.textContent = variant.available
          ? strings.inStock || 'In stock'
          : strings.soldOut || 'Sold out';
      }

      if (variant.url && window.history.replaceState) {
        window.history.replaceState({}, '', variant.url);
      }
    });
  })();

  /* --------------------------------------------------------------- gallery */

  (function productGalleries() {
    function initGallery(gallery) {
      if (gallery.getAttribute('data-gallery-ready') === 'true') return;
      gallery.setAttribute('data-gallery-ready', 'true');

      var slides = $$('[data-gallery-slide]', gallery);
      var thumbs = $$('[data-gallery-thumb]', gallery);
      var rail = $('[data-gallery-rail]', gallery);
      var currentLabel = $('[data-gallery-current]', gallery);
      var currentIndex = Math.max(
        0,
        thumbs.findIndex(function (thumb) {
          return thumb.getAttribute('aria-current') === 'true';
        })
      );
      var touchStartX = null;

      function updateRailButtons() {
        if (!rail) return;
        var atStart = rail.scrollLeft <= 2;
        var atEnd = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2;
        var prev = $('[data-gallery-rail-prev]', gallery);
        var next = $('[data-gallery-rail-next]', gallery);
        if (prev) prev.disabled = atStart;
        if (next) next.disabled = atEnd;
      }

      function selectMedia(index, scrollThumb) {
        if (!slides.length) return;
        currentIndex = (index + slides.length) % slides.length;

        slides.forEach(function (slide, slideIndex) {
          slide.classList.toggle('is-active', slideIndex === currentIndex);
        });
        thumbs.forEach(function (thumb, thumbIndex) {
          thumb.setAttribute('aria-current', thumbIndex === currentIndex ? 'true' : 'false');
        });
        if (currentLabel) currentLabel.textContent = String(currentIndex + 1);

        if (scrollThumb !== false && rail && thumbs[currentIndex]) {
          var activeThumb = thumbs[currentIndex];
          rail.scrollTo({
            left: activeThumb.offsetLeft - (rail.clientWidth - activeThumb.offsetWidth) / 2,
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
          });
        }
        window.requestAnimationFrame(updateRailButtons);
      }

      gallery.addEventListener('click', function (e) {
        var thumb = e.target.closest('[data-gallery-thumb]');
        if (thumb) {
          selectMedia(thumbs.indexOf(thumb));
          return;
        }
        if (e.target.closest('[data-gallery-prev]')) {
          selectMedia(currentIndex - 1);
          return;
        }
        if (e.target.closest('[data-gallery-next]')) {
          selectMedia(currentIndex + 1);
          return;
        }
        if (e.target.closest('[data-gallery-rail-prev]') && rail) {
          rail.scrollBy({ left: -Math.max(rail.clientWidth * 0.8, 120), behavior: 'smooth' });
        }
        if (e.target.closest('[data-gallery-rail-next]') && rail) {
          rail.scrollBy({ left: Math.max(rail.clientWidth * 0.8, 120), behavior: 'smooth' });
        }
      });

      gallery.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
        e.preventDefault();
        selectMedia(currentIndex + (e.key === 'ArrowRight' ? 1 : -1));
      });

      var main = $('.gallery__main', gallery);
      if (main) {
        main.addEventListener(
          'touchstart',
          function (e) {
            touchStartX = e.changedTouches.length ? e.changedTouches[0].clientX : null;
          },
          { passive: true }
        );
        main.addEventListener(
          'touchend',
          function (e) {
            if (touchStartX === null || !e.changedTouches.length) return;
            var distance = e.changedTouches[0].clientX - touchStartX;
            touchStartX = null;
            if (Math.abs(distance) < 45) return;
            selectMedia(currentIndex + (distance < 0 ? 1 : -1));
          },
          { passive: true }
        );
      }

      if (rail) rail.addEventListener('scroll', updateRailButtons, { passive: true });
      window.addEventListener('resize', debounce(updateRailButtons, 120));
      selectMedia(currentIndex, false);
    }

    $$('[data-gallery]').forEach(initGallery);
    document.addEventListener('shopify:section:load', function (e) {
      $$('[data-gallery]', e.target).forEach(initGallery);
    });
  })();

  /* ------------------------------------------------------ part number copy */

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-partno-copy]');
    if (!btn) return;

    var chip = btn.closest('[data-partno]');
    var valueEl = chip ? $('[data-partno-value]', chip) : null;
    if (!valueEl) return;

    var text = valueEl.textContent.trim();

    var done = function () {
      chip.classList.add('is-copied');
      btn.setAttribute('title', strings.copied || 'Copied');
      window.setTimeout(function () {
        chip.classList.remove('is-copied');
        btn.setAttribute('title', strings.copy || 'Copy');
      }, 1600);
    };

    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(text).then(done);
    } else {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      try {
        document.execCommand('copy');
        done();
      } catch (err) {
        /* no-op */
      }
      document.body.removeChild(ta);
    }
  });

  /* ---------------------------------------------------------------- facets */

  (function facets() {
    var form = $('[data-facet-form]');
    if (!form) return;

    function buildUrl() {
      var data = new FormData(form);
      var params = [];
      data.forEach(function (value, key) {
        if (value === '') return;
        params.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
      });
      var action = form.getAttribute('action') || window.location.pathname;
      return action.split('?')[0] + (params.length ? '?' + params.join('&') : '');
    }

    function apply(url) {
      setLoading(true);

      fetch(url)
        .then(function (r) {
          return r.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');

          var newResults = doc.querySelector('[data-facet-results]');
          var oldResults = $('[data-facet-results]');
          if (newResults && oldResults) oldResults.innerHTML = newResults.innerHTML;

          var newFacets = doc.querySelector('[data-facets]');
          var oldFacets = $('[data-facets]');
          if (newFacets && oldFacets) {
            var collapsed = oldFacets.getAttribute('data-collapsed');
            // Preserve which filter groups the shopper had expanded.
            var openStates = $$('.facet', oldFacets).map(function (d) {
              return d.open;
            });
            oldFacets.innerHTML = newFacets.innerHTML;
            oldFacets.setAttribute('data-collapsed', collapsed);
            $$('.facet', oldFacets).forEach(function (d, i) {
              if (typeof openStates[i] === 'boolean') d.open = openStates[i];
            });
          }

          window.history.pushState({ facets: true }, '', url);
        })
        .catch(function () {
          window.location.href = url;
        })
        .finally(function () {
          setLoading(false);
        });
    }

    var applyDebounced = debounce(function () {
      apply(buildUrl());
    }, 450);

    form.addEventListener('change', function (e) {
      if (e.target.type === 'number') return; // handled on input, debounced
      apply(buildUrl());
    });

    form.addEventListener('input', function (e) {
      if (e.target.type !== 'number') return;
      applyDebounced();
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      apply(buildUrl());
    });

    window.addEventListener('popstate', function () {
      window.location.reload();
    });

    // Mobile show/hide
    document.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-facets-toggle]');
      if (!toggle) return;
      var panel = $('[data-facets]');
      if (!panel) return;
      var collapsed = panel.getAttribute('data-collapsed') === 'true';
      panel.setAttribute('data-collapsed', collapsed ? 'false' : 'true');
      toggle.setAttribute('aria-expanded', collapsed ? 'true' : 'false');
    });
  })();

  /* ------------------------------------------------------ vehicle finder */

  (function vehicleFinder() {
    var finders = $$('[data-vehicle-finder]');
    if (!finders.length) return;

    var germanMakes = ['MERCEDES-BENZ', 'BMW', 'AUDI', 'VOLKSWAGEN', 'PORSCHE'];

    function saveVehicle(vehicle) {
      try {
        window.localStorage.setItem('maher-motors-vehicle', JSON.stringify(vehicle));
      } catch (err) {
        /* Browsing can continue when storage is unavailable. */
      }
    }

    function searchFor(action, terms) {
      var query = terms.filter(Boolean).join(' ');
      window.location.href = action + '?type=product&q=' + encodeURIComponent(query);
    }

    finders.forEach(function (finder) {
      var modeButtons = $$('[data-vehicle-mode]', finder);
      var forms = $$('[data-vehicle-form]', finder);

      modeButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          var mode = button.getAttribute('data-vehicle-mode');
          modeButtons.forEach(function (item) {
            item.setAttribute('aria-selected', item === button ? 'true' : 'false');
          });
          forms.forEach(function (form) {
            form.hidden = form.getAttribute('data-vehicle-form') !== mode;
          });
        });
      });

      var detailsForm = $('[data-vehicle-form="details"]', finder);
      if (detailsForm) {
        detailsForm.addEventListener('submit', function (event) {
          if (!detailsForm.checkValidity()) return;
          event.preventDefault();

          var vehicle = {
            year: $('[data-vehicle-year]', detailsForm).value,
            make: $('[data-vehicle-make]', detailsForm).value,
            model: $('[data-vehicle-model]', detailsForm).value.trim(),
            specification: $('[data-vehicle-spec]', detailsForm).value.trim()
          };

          saveVehicle(vehicle);
          searchFor(detailsForm.getAttribute('action'), [vehicle.year, vehicle.make, vehicle.model, vehicle.specification]);
        });
      }

      var vinForm = $('[data-vehicle-form="vin"]', finder);
      if (!vinForm) return;

      vinForm.addEventListener('submit', function (event) {
        event.preventDefault();

        var input = $('[data-vin-input]', vinForm);
        var status = $('[data-vin-status]', vinForm);
        var vin = input.value.trim().toUpperCase();
        var validVin = /^[A-HJ-NPR-Z0-9]{17}$/.test(vin);

        status.classList.remove('is-error');
        if (!validVin) {
          status.textContent = 'Enter a valid 17-character VIN. The letters I, O and Q are not used.';
          status.classList.add('is-error');
          input.focus();
          return;
        }

        status.textContent = 'Decoding vehicle...';
        input.disabled = true;

        fetch('https://vpic.nhtsa.dot.gov/api/vehicles/DecodeVinValuesExtended/' + encodeURIComponent(vin) + '?format=json')
          .then(function (response) {
            if (!response.ok) throw new Error('VIN service unavailable');
            return response.json();
          })
          .then(function (data) {
            var result = data && data.Results && data.Results[0];
            var make = result && result.Make ? result.Make.toUpperCase() : '';

            if (!result || !result.ModelYear || !make || !result.Model) {
              throw new Error('We could not decode enough vehicle details from that VIN.');
            }

            if (germanMakes.indexOf(make) === -1) {
              throw new Error('Maher Motors currently catalogs Mercedes-Benz, BMW, Audi, Volkswagen and Porsche vehicles.');
            }

            var vehicle = {
              year: result.ModelYear,
              make: result.Make,
              model: result.Model,
              specification: result.Trim || result.Series || result.EngineModel || ''
            };

            saveVehicle(vehicle);
            status.textContent = 'Found ' + [vehicle.year, vehicle.make, vehicle.model].join(' ') + '. Opening matching parts...';
            searchFor(vinForm.getAttribute('action'), [vehicle.year, vehicle.make, vehicle.model, vehicle.specification]);
          })
          .catch(function (error) {
            status.textContent = error.message || 'VIN lookup is temporarily unavailable. Search by vehicle details instead.';
            status.classList.add('is-error');
            input.disabled = false;
            input.focus();
          });
      });
    });
  })();

  /* ---------------------------------------------------- article contents */

  (function tableOfContents() {
    var body = $('[data-article-body]');
    var toc = $('[data-toc]');
    var list = $('[data-toc-list]');
    if (!body || !toc || !list) return;

    var headings = $$('h2', body);
    if (headings.length < 2) return;

    headings.forEach(function (h, i) {
      if (!h.id) h.id = 'section-' + (i + 1);
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent;
      li.appendChild(a);
      list.appendChild(li);
    });

    toc.hidden = false;
  })();

  /* --------------------------------------------------------- video poster */

  document.addEventListener('click', function (e) {
    var poster = e.target.closest('[data-video-play]');
    if (!poster) return;

    var wrap = poster.closest('[data-video]');
    var target = wrap ? $('[data-video-target]', wrap) : null;
    if (!target) return;

    var iframe = document.createElement('iframe');
    iframe.src = poster.getAttribute('data-video-embed');
    iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('title', poster.getAttribute('aria-label') || 'Video');

    target.appendChild(iframe);
    target.hidden = false;
    poster.remove();
  });

  /* ---------------------------------------------------------- misc helpers */

  // Print button
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-print]')) window.print();
  });

  // Confirm before destructive submits
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-confirm]');
    if (!btn) return;
    if (!window.confirm(btn.getAttribute('data-confirm'))) e.preventDefault();
  });

  // Generic show/hide toggle
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-toggle-target]');
    if (!toggle) return;
    var target = document.getElementById(toggle.getAttribute('data-toggle-target'));
    if (!target) return;
    var isHidden = target.hidden;
    target.hidden = !isHidden;
    toggle.setAttribute('aria-expanded', isHidden ? 'true' : 'false');
  });

  /* ----------------------------------------------- related product loading */

  (function relatedProducts() {
    var section = $('[data-related-products]');
    if (!section) return;

    var url = section.getAttribute('data-url');
    if (!url) return;

    fetch(url)
      .then(function (r) {
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-related-products]');
        if (fresh) section.innerHTML = fresh.innerHTML;
      })
      .catch(function () {
        /* no-op — the section simply stays empty */
      });
  })();

  /* --------------------------------------------- country / province select */

  (function addressSelectors() {
    var countrySelects = $$('[data-address-country]');
    if (!countrySelects.length) return;

    function init() {
      if (!window.Shopify || !window.Shopify.CountryProvinceSelector) return;

      countrySelects.forEach(function (select) {
        new window.Shopify.CountryProvinceSelector(
          select.id,
          select.getAttribute('data-province-id'),
          { hideElement: select.getAttribute('data-province-wrapper') }
        );
      });
    }

    if (window.Shopify && window.Shopify.CountryProvinceSelector) {
      init();
    } else {
      window.addEventListener('load', init);
    }
  })();
})();
